import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, logout as apiLogout } from '../services/api';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      // If parsing fails, user stays null
      console.error("Failed to parse user from localStorage", error);
    } finally {
      setLoading(false); // Set loading to false after checking
    }
  }, []);

  const login = async (username, password) => {
    try {
      const userData = await apiLogin(username, password);
      setUser(userData);
      navigate('/dashboard-v3');
    } catch (error) {
      // Handle login error (e.g., show a notification)
      console.error('Failed to login', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await apiLogout();
    } catch (error) {
      console.error('Logout failed on server, logging out client-side anyway.', error);
    } finally {
      setUser(null);
      localStorage.removeItem('user'); // Ensure user is removed from storage
      navigate('/login');
    }
  };

  const value = { user, loading, login, logout }; // Expose loading state

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};